import { __decorate } from "tslib";
import { EventEmitter, Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { ApiLookupConstants } from "../../../../constants/api-constants/api-lookup.constants";
import { AppControllerService } from "../../../../../app-controller.service";
import RecipientUtils from "../../../../utils/recipient-utils";
import { ApiRecipientVerificationConstants } from "../../../../constants/api-constants/api-recipient-verification.constants";
import { ApiRecipientConstants } from "../../../../constants/api-constants/api-recipient.constants";
import { ApiRecipientGroupSettingsConstants } from "src/app/shared/constants/api-constants/api-recipient-group-settings.constants";
let RecipientSelectService = class RecipientSelectService {
    http;
    appController;
    markFormControlAsTouched = new EventEmitter();
    resetForm = new EventEmitter();
    constructor(http, appController) {
        this.http = http;
        this.appController = appController;
    }
    checkStepMetaRecipientGroups(stepMetaGroups) {
        return stepMetaGroups.length > 0 ? RecipientUtils.mapStepMetaRecipientGroups(stepMetaGroups) : [];
    }
    getLookupsObservable() {
        const params = { $filter: `name eq 'RecipientGroup' and moduleId eq ${+this.appController.selectedModuleID}` };
        return this.http.get(ApiLookupConstants.URL, { params }).pipe(map((lookups) => {
            return lookups.value;
        }));
    }
    patchRecipientData(recipientToPatch, recipientId) {
        delete recipientToPatch.id;
        delete recipientToPatch.moduleId;
        delete recipientToPatch.jobId;
        return this.http.patch(`${ApiRecipientConstants.URL}/${recipientId}`, recipientToPatch).pipe(map(recipientResponse => {
            return recipientResponse;
        }));
    }
    verifySACAPRegistration(constituentId) {
        return this.http.get(`${ApiRecipientVerificationConstants.URL}/${constituentId}`, {});
    }
    setRecipient(recipient, overrideGroup, recipientControl, removeId = false) {
        const recipientDeepCopy = Object.assign({}, recipient);
        if (recipientDeepCopy.hasOwnProperty("id") && removeId) {
            delete recipientDeepCopy.id;
        }
        if (overrideGroup) {
            recipientDeepCopy.overrideGroup = overrideGroup;
        }
        recipientControl.setValue(recipientDeepCopy);
    }
    getRecipientGroupSettings() {
        const params = { $filter: `moduleId eq ${+this.appController.selectedModuleID}` };
        return this.http.get(ApiRecipientGroupSettingsConstants.URL, { params }).pipe(map((settings) => {
            return settings.value;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient },
        { type: AppControllerService }
    ];
};
RecipientSelectService = __decorate([
    Injectable({
        providedIn: "root"
    })
], RecipientSelectService);
export { RecipientSelectService };
